import { Icon } from '@/shared/types/icon';

export const SonioxIcon = ({ size = 16, className = '' }: Icon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        fill="#000"
        d="M8.65 2C6.17 2 4.3 3.25 4.3 5.15c0 1.65 1.2 2.55 3.35 3.05l1.15.27c1.3.3 1.85.72 1.85 1.43 0 .95-.88 1.55-2.25 1.55-1.5 0-2.55-.6-2.85-1.7H3.3C3.65 11.85 5.5 13 8.35 13c2.6 0 4.35-1.3 4.35-3.25 0-1.65-1.15-2.6-3.4-3.1L8.2 6.38c-1.2-.28-1.75-.68-1.75-1.33 0-.88.8-1.45 2.1-1.45 1.3 0 2.2.58 2.5 1.55h2.15C12.85 3.15 11.15 2 8.65 2Z"
      />
    </svg>
  );
};
